/*
 * Copyright (c) Castle Point Learning Systems Corporation, 2013-2023, all rights reserved.
 * NOTICE: Dissemination of the information and/or materials contained in this file is strictly
 * forbidden unless prior written permission is obtained from Castle Point Learning Systems Corporation.
 * See LICENSE.txt (part of this package) for the full notice.
 */

import { useCallback, useContext } from 'react';
import { EvaluationContext } from '../context/EvaluationContextProvider';
import { alignLines, calcEqualityOffset } from '../utils/evaluationUtils';

export const useEvaluationAlign = (lineId: string) => {
    const { dispatchEvaluation } = useContext(EvaluationContext);

    return useCallback(() => {
        dispatchEvaluation((prevState) => {
            return {
                ...prevState,
                lines: alignLines(prevState.lines.map((l) => (lineId === l.id ? calcEqualityOffset(l) : l))),
            };
        });
    }, [lineId, dispatchEvaluation]);
};
